import { render, staticRenderFns } from "./togetherAiImage.vue?vue&type=template&id=3b4dee0a&scoped=true"
import script from "./togetherAiImage.vue?vue&type=script&lang=js"
export * from "./togetherAiImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4dee0a",
  null
  
)

export default component.exports